import { Box, IconV2, TableV2 } from '@/elements';
import { Tooltip } from '@mui/material';
import React from 'react';
import { statusOptions } from '@/common/pages/users/store/index.js';
import dateFormat from 'dateformat';

export default function UserTable({
  data,
  onPageChange,
  onSortingChange,
  onFiltersChange,
  totalCount,
  totalPages,
  loading,
  queryParams,
}) {
  const columns = [
    {
      id: 'id',
      header: 'ID',
      body: 'id',
      enableColumnFilter: true,
      enableSorting: true,
      minWidth: 115,
      width: 115,
    },
    {
      id: 'email',
      header: 'Email',
      body: ({ row }) => {
        const email = row?.original?.email ?? '-';
        const isTruncated = email?.length > 30;
        const displayText = isTruncated ? `${email.slice(0, 30)}...` : email;

        const content = <span style={{ whiteSpace: 'nowrap' }}>{displayText}</span>;

        return isTruncated ? <Tooltip title={email}>{content}</Tooltip> : content;
      },
      enableColumnFilter: true,
      minWidth: 155,
      width: 260,
    },
    {
      id: 'name',
      header: 'Name',
      body: ({ row }) => {
        const fullName = row?.original?.name?.first
          ? `${row?.original?.name?.first} ${row?.original?.name?.last}`
          : '-';
        const isTruncated = fullName?.length > 30;
        const displayText = isTruncated ? `${fullName.slice(0, 30)}...` : fullName;

        const content = <span style={{ whiteSpace: 'nowrap' }}>{displayText}</span>;

        return isTruncated ? <Tooltip title={fullName}>{content}</Tooltip> : content;
      },
      minWidth: 155,
      width: 260,
    },
    {
      id: 'partnerClientAccountId',
      header: 'Account ID',
      body: 'partnerClientAccountId',
      enableColumnFilter: true,
      minWidth: 155,
    },
    {
      id: 'groups',
      header: 'Access groups',
      body: ({ row }) => {
        const groups = row?.original?.groups;
        const groupsNames = groups.map((group) => group?.name);

        if (!groupsNames || !groupsNames.length) {
          return '-';
        }

        return (
          <Box direction="column">
            {groupsNames?.map((groupName) => {
              const isTruncated = groupName?.length > 40;
              const displayText = isTruncated ? `${groupName.slice(0, 40)}...` : groupName;

              const content = (
                <span
                  style={{
                    whiteSpace: 'nowrap',
                  }}
                >
                  {displayText}
                </span>
              );

              return isTruncated ? <Tooltip title={groupName}>{content}</Tooltip> : content;
            })}
          </Box>
        );
      },
      minWidth: 215,
      width: 320,
    },
    {
      id: 'role',
      header: 'Administrator',
      body: ({ row }) => (row?.original?.isInDefaultGroup ? <IconV2 name="check"></IconV2> : '-'),
      minWidth: 155,
    },
    {
      id: 'status',
      header: 'Status',
      enableSorting: true,
      body: ({ row }) =>
        row?.original?.deletedAt ? statusOptions.DELETED : statusOptions[row?.original?.status],
      minWidth: 155,
    },
    {
      id: 'authenticationType',
      header: 'Authentication type',
      body: ({ row }) => row?.original?.authenticationType,
      minWidth: 155,
    },
    {
      id: 'createdAt',
      header: 'Created at',
      body: ({ getValue }) => dateFormat(getValue(), 'dd/mm/yy HH:MM'),
      minWidth: 155,
    },
  ];
  return (
    <TableV2
      data={data}
      loading={loading}
      onPageChange={onPageChange}
      onSortingChange={onSortingChange}
      onFiltersChange={onFiltersChange}
      totalCount={totalCount}
      totalPages={totalPages}
      columns={columns}
      size={queryParams.limit}
      page={queryParams.page}
    />
  );
}
